import classNames from 'classnames';
import EditorImg from 'lowcode/components/EditorImg';
import EditorVideo from 'lowcode/components/EditorVideo';
import React, { useEffect, useRef, useState } from 'react';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EfMessageLR from '../ef-message-l-r';
import './index.scss';

interface EfSwiperLevel2ItemProps {
    /**
     * 手机端是多张图片列表
     */
    h5List?: string[];
    /**
     * 左上标题
     */
    upTitle?: string;
    /**
     * 左侧标题
     */
    subtitle?: string;
    /**
     * 右侧描述
     */
    desc?: string;
    /**
     * 右侧提示语
     */
    tips?: string;
    /**
     * 电脑端图片
     */
    pc?: string;
    /**
     * 手机端图片
     */
    h5?: string;
    /**
     * isChangeImg2
     */
    isChangeImg2?: boolean;
    /**
     * isChangeImg2 对应的电脑端图片
     */
    pc2?: string;
    /**
     * isChangeImg2 对应的手机端图片
     */
    h52?: string;
}
interface EfSwiperLevel2Props {
    /**
     * 样式名
     */
    className?: string;
    /**
     * 是否拥有2级切换轮播
     */
    hasLevel2?: boolean;
    /**
     * 列表
     */
    list?: EfSwiperLevel2ItemProps[];
}

/**
 * 维护:谢保林
 *
 * 电脑端单层轮播
 * 手机端双层轮播
 */
const EfSwiperLevel2: React.FC<EfSwiperLevel2Props> = ({ hasLevel2 = false, list = [] }) => {
    const prefixCls = `ef-swiper-level2`;
    const classes = classNames(prefixCls, {});
    const [isMobile, setIsMobile] = useState(false);
    const [active, setActive] = useState(0);
    const refWrapper = useRef(null);

    useEffect(() => {
        // const resizeObserver = new ResizeObserver((entries) => {
        //     for (const entry of entries) {
        //         // 处理观察到的目标大小变化
        //         const innerWidth = window.innerWidth;
        //         if (innerWidth > 1024) {
        //             setIsMobile(false);
        //         } else {
        //             setIsMobile(true);
        //         }
        //     }
        // });

        // resizeObserver.observe(document.body);

        const innerWidth = window.innerWidth;
        if (innerWidth > 1024) {
            setIsMobile(false);
        } else {
            setIsMobile(true);
        }
    }, []);
    // 点击上一个
    const handlePrev = (e: any) => {
        e.stopPropagation();
        const newActive = active === 0 ? list?.length - 1 : active - 1;
        setActive(newActive);
        handleScroll(newActive);
    };
    // 点击下一个
    const handleNext = (e: any) => {
        e.stopPropagation();
        const newActive = active === list?.length - 1 ? 0 : active + 1;
        setActive(newActive);
        handleScroll(newActive);
    };
    // 点击分页
    const handleScroll = (idx: number) => {
        const wrapper = refWrapper.current as any;

        if (wrapper) {
            const { scrollWidth } = wrapper;
            // console.log('wrapper', wrapper, wrapper.scrollWidth, idx, list.length);
            wrapper.style.left = `${-idx * (scrollWidth / list?.length)}px`;
        }
    };

    return (
        <div className={classes}>
            {(!hasLevel2 || !isMobile) && (
                <Swiper
                    className={`${prefixCls}-list ef-mod-swiper-tools`}
                    modules={[Navigation, Pagination]}
                    navigation={true}
                    pagination={true}
                    loop={true}
                    slidesPerView={'auto'}
                    initialSlide={0}
                >
                    {list?.map((item: any, k: number) => (
                        <SwiperSlide className={`${prefixCls}-item`} key={k}>
                            {item.upTitle && <div className={`${prefixCls}-up-title`}>{item.upTitle}</div>}
                            <div className={`${prefixCls}-img`}>
                                <EditorImg pc={item.pc} h5={item?.h5 || item?.pc} />
                                {item.isChangeImg2 && <EditorImg className={`${prefixCls}-img-change2`} pc={item.pc2} h5={item.h52} />}
                            </div>
                            <EfMessageLR lTitle={item.subtitle} rTitle={item.desc} rTips={item.tips} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            )}
            {hasLevel2 && isMobile && (
                <>
                    <div className={`${prefixCls}-swiper-l1`}>
                        <ul className={`${prefixCls}-swiper-l1-wrapper`} ref={refWrapper}>
                            {list?.map((item: EfSwiperLevel2ItemProps, index1: number) => {
                                const h5List = item.h5List || [];
                                const hasSwiper = h5List.length > 0;
                                return (
                                    <li key={index1} className={`${prefixCls}-swiper-l1-item${active === index1 ? ' swiper-slide-active' : ''}`}>
                                        {item.upTitle && <div className={`${prefixCls}-up-title`}>{item.upTitle}</div>}
                                        {!hasSwiper && (
                                            <div className={`${prefixCls}-img`}>
                                                <EditorImg pc={item.pc} h5={item?.h5 || item?.pc} />
                                                {item.isChangeImg2 && <EditorImg className={`${prefixCls}-img-change2`} pc={item.pc2} h5={item.h52} />}
                                            </div>
                                        )}
                                        {hasSwiper && (
                                            <>
                                                <Swiper
                                                    className={`${prefixCls}-swiper-l2`}
                                                    modules={[Pagination]}
                                                    pagination={true}
                                                    loop={true}
                                                    spaceBetween={0}
                                                    // centeredSlides={true}
                                                    slidesPerView={'auto'}
                                                    initialSlide={0}
                                                >
                                                    {h5List.map((item2: any, index2: number) => {
                                                        const isVideo = item2.endsWith('.mp4');
                                                        return (
                                                            <SwiperSlide className={`swiper-list`} key={`${index1}_${index2}`}>
                                                                <div className={`${prefixCls}-img`}>
                                                                    {isVideo ? (
                                                                        <EditorVideo pc={item2} autoPlay={true} loop={true} />
                                                                    ) : (
                                                                        <EditorImg pc={item2} />
                                                                    )}
                                                                </div>
                                                            </SwiperSlide>
                                                        );
                                                    })}
                                                </Swiper>
                                            </>
                                        )}
                                        <EfMessageLR lTitle={item.subtitle} rTitle={item.desc} rTips={item.tips} />
                                    </li>
                                );
                            })}
                        </ul>
                        <ul className="ef-swiper-pagination">
                            <li className="ef-swiper-button-prev" onClick={handlePrev}></li>
                            {list?.map((pagination: any, k: number) => (
                                <li
                                    className={`ef-swiper-pagination-bullet${active === k ? ' ef-swiper-pagination-bullet-active' : ''}`}
                                    key={k}
                                    onClick={() => {
                                        handleScroll(k);
                                    }}
                                ></li>
                            ))}
                            <li className="ef-swiper-button-next" onClick={handleNext}></li>
                        </ul>
                    </div>
                </>
            )}
        </div>
    );
};

export default EfSwiperLevel2;
